(function ($) {
  "use strict";
  $(document).ready(function () {
    var accordionLists = $(".ajax_append_holder").find("section.accordion");
    for (var i = 0; i < accordionLists.length; i++) {
      if (!$(accordionLists[i]).find("h2").hasClass("visuallyhidden")) {
        $(accordionLists[i]).find("h2").find("button").trigger("click");
        break;
      }
    }
    $("#Form_FilterForm_sorting").on("click", "input", function (e) {
      var form = $(this).attr("form");
      $("#" + form).submit();
    });
  });
})(jQuery);

/**
 * Scroll to active filter forms when the page loads.
 * @see WSSearchFormTemplate::getForm()
 */
(function ($) {
  var form = $("form.filter-form--active");

  if (form.length) {
    form[0].scrollIntoView({
      behavior: "auto",
      block: "start",
      inline: "start",
    });
  }
})(jQuery);

/**
 * Scroll to element matching URL hash when the page loads.
 */
(function ($) {
  if (window.location.hash) {
    setTimeout(function () {
      var target = $(window.location.hash);
      if (target.length) {
        target[0].scrollIntoView({
          behavior: "auto",
          block: "start",
          inline: "start",
        });
      }
    }, 1000);
  }
})(jQuery);

/**
 * the following code is to fix html5 form attribute that are not
 */
(function ($) {
  /**
   * polyfill for html5 form attr
   */
  // detect if browser supports this
  var sampleElement = $("[form]").get(0);

  var form = document.getElementById($(sampleElement).attr("form"));
  var isIE11 = !window.ActiveXObject && "ActiveXObject" in window;
  var isLessEdge15Inclusive = false;
  var ua = window.navigator.userAgent;
  var edge = ua.indexOf("Edge/");

  if (edge > 0) {
    if (parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10) <= 15) {
      isLessEdge15Inclusive = true;
    }
  }

  if (
    sampleElement &&
    window.HTMLFormElement &&
    form instanceof HTMLFormElement &&
    !(isIE11 || isLessEdge15Inclusive)
  ) {
    // browser supports it, no need to fix
    return;
  }

  /**
   * Append a field to a form
   *
   */
  $.fn.appendField = function (data) {
    // for form only
    if (!this.is("form")) return;

    // wrap data
    if (!$.isArray(data) && data.name && data.value) {
      data = [data];
    }

    var $form = this;

    // attach new params
    $.each(data, function (i, item) {
      $("<input/>")
        .attr("type", "hidden")
        .attr("name", item.name)
        .val(item.value)
        .appendTo($form);
    });

    return $form;
  };

  /**
   * Find all input fields with form attribute point to jQuery object
   *
   */
  $("form[id]")
    .submit(function (e) {
      var $form = $(this);
      // serialize data
      var data = $("[form=" + $form.attr("id") + "]").serializeArray();
      // append data to form
      $form.appendField(data);
    })
    .each(function () {
      var form = this,
        $form = $(form),
        $fields = $("[form=" + $form.attr("id") + "]");

      $fields
        .filter("button, input")
        .filter("[type=reset],[type=submit]")
        .click(function () {
          var type = this.type.toLowerCase();
          if (type === "reset") {
            // reset form
            form.reset();
            // for elements outside form
            $fields
              .each(function () {
                this.value = this.defaultValue;
                this.checked = this.defaultChecked;
              })
              .filter("select")
              .each(function () {
                $(this)
                  .find("option")
                  .each(function () {
                    this.selected = this.defaultSelected;
                  });
              });
          } else if (type.match(/^submit|image$/i)) {
            $(form)
              .appendField({ name: this.name, value: this.value })
              .submit();
          }
        });
    });
})(jQuery);
